import React, { useEffect } from 'react';
import '../BitsStyles/Expertise.css';
import explore1 from '../BitsImages/careersgraduate.jpeg';
import explore2 from '../BitsImages/careersexperinced.webp';
import explore3 from '../BitsImages/careers executives.jpeg';

const services = [
  {
    title: 'Students and Graduates',
    description: 'Graduates and Freshers are always welcome at our company. Come and showcase your skills at Bellary Info Tech Solutions.',
    image: explore1,
    icon: 'bi-mortarboard',
  },
  {
    title: 'Experienced Professionals',
    description: 'Experienced professionals are always at the forefront of a company\'s success. Bring your expertise and help us lead.',
    image: explore2,
    icon: 'bi-briefcase',
  },
  {
    title: 'Executives',
    description: 'Visionary executives are crucial to running a great company. Come and join us to shape the future of BITS.',
    image: explore3,
    icon: 'bi-star',
  },
];

const Explorecareers = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.service-box-bits').forEach(box => observer.observe(box));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="explore-careers-section">
      <div className="explore-careers-header">
        <h1 className="explore-careers-title">
          Looking for an exciting role and plenty of opportunities?
        </h1>
        <p className="explore-careers-sub">
          Each of our professions will help you build your learning agility to make sure you have the
          right skill at the right time in today's fast-paced market. These professions are key to our
          strategy to deliver value to our clients.
        </p>
      </div>

      <div className="services-container-bits">
        {services.map((service, index) => (
          <div className="service-box-bits" key={index} data-animate="slideUp">
            <div className="service-image-bits">
              <img src={service.image} alt={service.title} />
              <div className="service-image-overlay">
                <i className={`bi ${service.icon}`}></i>
              </div>
            </div>
            <div className="service-text-bits">
              <h2 className="service-box-title">{service.title}</h2>
              <p className="service-box-desc">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Explorecareers;
